<div class="duplicated-prospects-container">
  @for (prospect of duplicatedProspects(); track prospect.id) {
    <div tiimeProperties>
      <div>
        <div tiimeIconProperty>
          <mat-icon svgIcon="icon-user"></mat-icon>
          <span class="italic ellipsis" tiimeFallbackText>
            {{ prospect.fullName }}
          </span>
        </div>
        <div tiimeIconProperty>
          <mat-icon svgIcon="icon-phone"></mat-icon>
          <span class="italic ellipsis" tiimeFallbackText>
            {{ prospect.phone | phone }}
          </span>
        </div>
        <div tiimeIconProperty>
          <mat-icon svgIcon="icon-mail"></mat-icon>
          <span class="italic ellipsis" tiimeFallbackText>
            {{ prospect.email }}
          </span>
        </div>
      </div>
      <div>
        <div tiimeProperty>
          <span class="nowrap">Groupe</span>
          <span class="italic ellipsis" tiimeFallbackText>
            {{ prospect.businessUnit?.name }}
          </span>
        </div>
        <div tiimeProperty>
          <span class="nowrap">Réf. commercial</span>
          <span class="italic ellipsis" tiimeFallbackText>
            {{ prospect.salesRepresentativeUser?.fullName }}
          </span>
        </div>
        <div tiimeProperty>
          <span class="nowrap">Contrats</span>
          <span class="italic ellipsis" tiimeFallbackText>
            {{ prospect.contracts?.length }}
            @if (prospect.contracts | map: mapToSignedContracts; as signedContracts) {
              ( dont {{ signedContracts }}
              <ng-container [ngPlural]="signedContracts">
                <ng-template ngPluralCase="=1">signé</ng-template>
                <ng-template ngPluralCase="other">signés</ng-template>
              </ng-container>
              )
            }
          </span>
        </div>
      </div>
    </div>
  }
</div>
